// extracted by mini-css-extract-plugin
module.exports = {"header":"theme_header__FJXGN"};